import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface IDistributorUser {
  username: string;
  email: string;
  distributorUserType: string;
  password?: string;
}

export default function useBulkCreateDistributorUsers() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  async function execute(usersData: IDistributorUser[]) {
    try {
      setLoading(true);
      const response = await api.post(
        `v1/backoffice/distributor-users/bulk`,
        usersData,
      );

      if (response.status === 201) {
        history.push('/home/configurations');
        toast.success(
          ToastMessages.distributorUser.success.registerDistributorUser,
        );
      }

      if (response.status === 400) {
        toast.error(ToastMessages.distributorUser.error.conflitUser);
      }
    } catch (error) {
      toast.error(ToastMessages.distributorUser.error.registerDistributorUser);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
